import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Row, Content } from '../components/Layout.js'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import Carousel from '../components/Carousel'
import Card from '../components/Card'
import Button from '../components/Button'

const heroOptions = {
  header: '<strong>bronze</strong><br>mobile.wkr',
  buttons: [
    {
      icon: 'ac-mail',
      text: 'Try a demo',
      link: 'https://portal-test.framework42.com/demo',
      target: '_blank'
    },
    {
      icon: 'ac-login',
      text: 'Login to your system',
      link: 'https://portal-test.framework42.com',
      target: '_blank'
    }
  ],
  subtext:
    'The complete mobile working solution that brings quantifiable benefits to your business.',
  background: 'mobwkr_bg'
}

class MobileWKR extends Component {
  render () {
    const { featureCards, featureVideos, clients } = this.props
    return (
      <div className='mainContainer'>
        <Hero options={heroOptions} />
        <section className='noVerticalPadding'>
          {/*
          <Row>
            <Content classes={['contentFull']}>
              <h2>What is mobile.wkr?</h2>
            </Content>
          </Row>

           <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</span>
            </Content>
          </Row> */}

          <Row>
            <Content classes={['contentFull']}>
              <h2>Why would it benefit me?</h2>
            </Content>
          </Row>
          <Row>
            <Content classes={['contentFull']}>
              <span>
                mobile.wkr is a continually evolving product and offers
                scalability with your business. Increase productivity with
                mobile.wkr and remove the barriers that prevent a job running
                smoothly. It facilitates operational changes, offers improved
                service response, higher customer service levels and increased
                operational capacity, leaving you to get more done with the
                resources that you have.
              </span>
            </Content>
          </Row>
          {featureCards && featureCards.length > 0 && (
            <Carousel>
              {featureCards.map((card, index) => (
                <Card options={card} key={index} />
              ))}
            </Carousel>
          )}
          <Row>
            <Content classes={['contentFull']}>
              <h2>Features that improve business flow.</h2>
            </Content>
          </Row>
          <Row>
            <Content classes={['contentFull']}>
              <p>
                mobile.wkr has a fantastic range of standard features that helps
                you to organise and work better.
              </p>
            </Content>
          </Row>
          {featureVideos && featureVideos.length > 0 && (
            <Carousel itemsToShow={1} autoplay={false}>
              {featureVideos.map((card, index) => (
                <Card video full options={card} key={index} />
              ))}
            </Carousel>
          )}
          <Row>
            <Content classes={['contentFull']}>
              <h2>Who has it benefited?</h2>
            </Content>
          </Row>
          {clients && clients.length > 0 && (
            <Carousel>
              {clients.map((card, index) => (
                <Card options={card} key={index} />
              ))}
            </Carousel>
          )}
        </section>
        <section id='interested' className='alternate'>
          <div className='backgroundHex' />
          <div className='backgroundHex' />
          <Row>
            <Content classes={['contentFull']}>
              <h2>Interested?</h2>
            </Content>
          </Row>
          <Row>
            <Content classes={['contentFull', 'noPadding']}>
              <p>
                To find out more about mobile.wkr<br />and to discuss your
                needs.
              </p>
            </Content>
          </Row>
          <Row>
            <Content classes={['contentFull']}>
              <Button
                icon='ac-mail'
                classes={['button-primary noMargin']}
                text='Get in touch'
                href='mailto:info@bronzelabs.co.uk?subject=I want to find out more about mobile.wkr&body=Hello, I would love to hear more about mobile.wkr, here are my details for you to contact me.'
              />
            </Content>
          </Row>
        </section>
        <Footer />
      </div>
    )
  }
}

MobileWKR.propTypes = {
  featureCards: PropTypes.array,
  featureVideos: PropTypes.array,
  clients: PropTypes.array
}

export default MobileWKR



// WEBPACK FOOTER //
// ./src/containers/MobileWKR.js